import axios from "axios"
export const saveZelleDetails = (bData, token) => {
   return axios.post(process.env.REACT_APP_API_URL+ '/addZelle', bData, {
      headers: {
          'Authorization': `${token}`
      }});
}